import {API_ADMIN_URL} from '../../config/constants'
import { postRequest, fetchIpAddress } from '../API'

/*********************************************************
* Function Name : List
* Description   : Get list of all faq
* By            : Sumit Bedwal
* Date          : 28-11-2024 
*********************************************************/
export const list = async (options, cancelToken) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}academics/domains/list`,
            postData : options
        }
        const res = await postRequest(params,cancelToken);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addEditData
* Description   : Add/Edit faq
* By            : Sumit Bedwal
* Date          : 28-11-2024 
*********************************************************/
export const addEditData = async (options) =>{
    try {
        const { url, postData={} } = options;
        const params = {
            url: `${API_ADMIN_URL}${options.url}`,
            postData: options.postData
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : chnageStatus
* Description   : chnage faq status
* By            : Sumit Bedwal
* Date          : 28-11-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const { url, postData={} } = options;
        const params = {
            url : `${API_ADMIN_URL}${url}`,
            postData : {
                ...postData,
                ipAddress : await fetchIpAddress()
            }
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteCategory
* Description   : delete faq
* By            : Sumit Bedwal
* Date          : 28-11-2024
*********************************************************/
export const deleteAcademicsDomains = async (options) =>{
    try {
        const { url, postData={} } = options;
        const params = {
            url : `${API_ADMIN_URL}academics/domains/delete`,
            postData : {
                ...options,
                ipAddress : sessionStorage.getItem('IP_ADDRESS')
            }
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
